export const FTS_COMMON = 'ftsCommon';

export const FTS_COMMON_ACTIONS_NAME = {
  searchCustomsProcedures: `${FTS_COMMON}/searchCustomsProcedures`,
  searchProductsGroups: `${FTS_COMMON}/searchProductsGroups`,
  searchProductsTwoSigns: `${FTS_COMMON}/searchProductsTwoSigns`,
  searchProductsFourSigns: `${FTS_COMMON}/searchProductsFourSigns`,
  searchProductsSixSigns: `${FTS_COMMON}/searchProductsSixSigns`,
  searchProductsEightSigns: `${FTS_COMMON}/searchProductsEightSigns`,
  searchProductsNineSigns: `${FTS_COMMON}/searchProductsNineSigns`,
  searchProductsTenSigns: `${FTS_COMMON}/searchProductsTenSigns`,
  searchOkatoTree: `${FTS_COMMON}/searchOkatoTree`,
  searchCountriesTree: `${FTS_COMMON}/searchCountriesTree`,
} as const;

export const FTS_COMMON_MUTATIONS_NAME = {
  setCustomsProcedures: `${FTS_COMMON}/setCustomsProcedures`,
  setProductsGroups: `${FTS_COMMON}/setProductsGroups`,
  setProductsTwoSigns: `${FTS_COMMON}/setProductsTwoSigns`,
  setProductsFourSigns: `${FTS_COMMON}/setProductsFourSigns`,
  setProductsSixSigns: `${FTS_COMMON}/setProductsSixSigns`,
  setProductsEightSigns: `${FTS_COMMON}/setProductsEightSigns`,
  setProductsNineSigns: `${FTS_COMMON}/setProductsNineSigns`,
  setProductsTenSigns: `${FTS_COMMON}/setProductsTenSigns`,
  setOkatoTree: `${FTS_COMMON}/setOkatoTree`,
  setCountriesTree: `${FTS_COMMON}/setCountriesTree`,
} as const;

export const FTS_COMMON_GETTERS_NAME = {
  getCustomsProcedures: `${FTS_COMMON}/getCustomsProcedures`,
  getProductsGroups: `${FTS_COMMON}/getProductsGroups`,
  getProductsTwoSigns: `${FTS_COMMON}/getProductsTwoSigns`,
  getProductsFourSigns: `${FTS_COMMON}/getProductsFourSigns`,
  getProductsSixSigns: `${FTS_COMMON}/getProductsSixSigns`,
  getProductsEightSigns: `${FTS_COMMON}/getProductsEightSigns`,
  getProductsNineSigns: `${FTS_COMMON}/getProductsNineSigns`,
  getProductsTenSigns: `${FTS_COMMON}/getProductsTenSigns`,
  getOkatoTree: `${FTS_COMMON}/getOkatoTree`,
  getCountriesTree: `${FTS_COMMON}/getCountriesTree`,
} as const;
